import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { fusionAuthService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseUnlinkFusionAuthUserMutationProps = {
	userId: string;
	onSuccess: Function;
};

const useUnlinkFusionAuthUserMutation = ({
	userId,
	onSuccess,
}: UseUnlinkFusionAuthUserMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		() => {
			return fusionAuthService.unlinkUser({
				userId,
			});
		},
		{
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "SSO ID is successfully unlinked to RISE user",
					}),
				);
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUnlinkFusionAuthUserMutation;
